<div class="hero-image-container">
  <img
    [src]="
      imageUrl ||
      environment.cloudFrontUrl +
        '/content/welcome/welcome-banner-horizontal.png '
    "
    alt=""
    role="presentation"
    class="hero-image"
  />
  <!-- <h1>{{ title }}</h1> -->
</div>
